import { GridFooterCellProps } from "@progress/kendo-react-grid";
import { useTheme } from "@mui/material";
import { zeroPadForOne } from "../ZeroPadForOne";
import { StopDataFooterProps } from "./StopDataFooterProps";
import { colorShade } from "../../../../../../Layout/Grid/Cell/KendoReactColoredFooterCell";

export default function StopDataDrivingHoursSumCell({
  routings,
  colSpan,
}: StopDataFooterProps & GridFooterCellProps) {
  let hoursTotal = 0;
  let minutesTotal = 0;
  const theme = useTheme();

  const routingsWithValidDrivingHours = routings
    .filter((it) => it.DrivingHours && it.DrivingHours.indexOf(":") >= 0)
    .map((it) => ({
      ...it,
      DrivingHours: it.DrivingHours || "",
    }));

  routingsWithValidDrivingHours.forEach((routing) => {
    const [hours, minutes] = routing.DrivingHours.split(":").map((it) => parseInt(it, 10));
    if (!(Number.isNaN(hours) || Number.isNaN(minutes))) {
      hoursTotal += hours;
      minutesTotal += minutes;
    }
  });

  if (minutesTotal >= 60) {
    const minutesToTotalHourDiff = minutesTotal % 60;
    const additionalHoursByMinutes = Math.floor(minutesTotal / 60);
    hoursTotal += additionalHoursByMinutes;
    minutesTotal = minutesToTotalHourDiff;
  }

  return (
    <td colSpan={colSpan} style={{ backgroundColor: theme.palette.grey[colorShade] }}>
      {`${zeroPadForOne(hoursTotal)}:${zeroPadForOne(minutesTotal)}`}
    </td>
  );
}
